import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Subscription } from 'rxjs';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'nav-trail',
    templateUrl: 'navtrail.component.html',
    styleUrls: ['navtrail.component.scss'],
    standalone: false
})
export class NavTrailComponent implements OnInit, OnDestroy {

  public isCollapsed = false;
  profilePicture: string = null;
  private subscrptions: Subscription[] = new Array<Subscription>();

  constructor(private router: Router, private authService: AuthService) {
  }

  ngOnInit() {

  }

  ngOnDestroy(): void {
    for (let subscirption of this.subscrptions) {
      if (subscirption) {
        subscirption.unsubscribe();
      }
    }
  }

  isExpanded = false;

  public collapse() {
    this.isExpanded = false;
  }

  public toggle() {
    this.isExpanded = !this.isExpanded;
  }

  get routeTerminals(): boolean {
    return this.router.url.includes("terminals");
  }

  get isLogin(): boolean {
    if (this.authService) {
      return this.authService.isLoggedIn;
    }
    return false;
  }

  public logout() {
    if (this.authService.isLoggedIn) {
      this.authService.logout().then(res => {
        this.authService.redirectLogoutUser();
      });
    }
  }

}
